import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Icon, Select } from 'antd';
import style from '../../Views/TimeSheet/style.module.css';
import {
  REQUEST_GET_ALL_USERS_FOR_ADMIN,
  SELECT_USER_FOR_TIMESHEET,
} from '../../Redux/constants/constants';

const { Option } = Select;

const findIndexFromId = (arrayOfUsers, id) => {
  return arrayOfUsers.findIndex((user) => user.id === id);
};

const findNextIdFromIndex = (arrayOfUsers, index) => {
  if (index === arrayOfUsers.length - 1) {
    return arrayOfUsers[index].id;
  }
  return arrayOfUsers[index + 1].id;
};

const findPrevIdFromIndex = (arrayOfUsers, index) => {
  if (index === 0) {
    return arrayOfUsers[index].id;
  }
  return arrayOfUsers[index - 1].id;
};

const TimeSheetSelectUser = () => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.users);
  const selectedUserIdForTimeSheet = useSelector(
    (state) => state.selectedUserIdForTimeSheet
  );
  const [selectedUserName, setSelectedUserName] = useState(
    'Wybierz pracownika'
  );

  useEffect(() => {
    dispatch({ type: REQUEST_GET_ALL_USERS_FOR_ADMIN });
  }, []);

  // get name of user when id changes
  useEffect(() => {
    if (users && selectedUserIdForTimeSheet) {
      const name =
        users[findIndexFromId(users, selectedUserIdForTimeSheet)].name;
      setSelectedUserName(name);
    }
  }, [selectedUserIdForTimeSheet]);

  const onChange = (id) => {
    console.log(`selected ${id}`);
    dispatch({ type: SELECT_USER_FOR_TIMESHEET, payload: id });
  };

  const onBlur = () => {
    console.log('blur');
  };

  const onFocus = () => {
    console.log('focus');
  };

  const onSearch = (val) => {
    console.log('search:', val);
  };

  const onSelectPrev = () => {
    if (selectedUserIdForTimeSheet === '') {
      dispatch({ type: SELECT_USER_FOR_TIMESHEET, payload: users[0].id });
    }
    if (selectedUserIdForTimeSheet !== '') {
      const currentIndex = findIndexFromId(users, selectedUserIdForTimeSheet);
      const prevId = findPrevIdFromIndex(users, currentIndex);
      dispatch({
        type: SELECT_USER_FOR_TIMESHEET,
        payload: prevId,
      });
    }
  };

  const onSelectNext = () => {
    if (selectedUserIdForTimeSheet === '') {
      dispatch({ type: SELECT_USER_FOR_TIMESHEET, payload: users[0].id });
    }
    if (selectedUserIdForTimeSheet !== '') {
      const currentIndex = findIndexFromId(users, selectedUserIdForTimeSheet);
      const nextId = findNextIdFromIndex(users, currentIndex);
      dispatch({
        type: SELECT_USER_FOR_TIMESHEET,
        payload: nextId,
      });
    }
  };

  return (
    <>
      <Button className={style.withSmallMargin} onClick={onSelectPrev}>
        <Icon type="left" />
      </Button>
      <Select
        showSearch
        style={{ width: 228 }}
        placeholder="Wybierz pracownika"
        optionFilterProp="children"
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onSearch={onSearch}
        value={selectedUserName}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {users.map((user) => (
          <Option key={user.id} value={user.id}>
            {user.name}
          </Option>
        ))}
      </Select>
      <Button className={style.withBigMargin} onClick={onSelectNext}>
        <Icon type="right" />
      </Button>
    </>
  );
};

export default TimeSheetSelectUser;
